var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.257,
    cy: 18.257,
    r: 18.257,
    fill: "#0B66C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3222 25.3234V20.3424C25.3222 17.8944 24.7952 16.0244 21.9392 16.0244C20.5622 16.0244 19.6442 16.7724 19.2702 17.4864H19.2362V16.2454H16.5332V25.3234H19.3552V20.8184C19.3552 19.6284 19.5762 18.4894 21.0382 18.4894C22.4832 18.4894 22.5002 19.8324 22.5002 20.8864V25.3064H25.3222V25.3234Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9434 16.2461H14.7654V25.3241H11.9434V16.2461Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3547 11.7236C12.4537 11.7236 11.7227 12.4546 11.7227 13.3556C11.7227 14.2566 12.4537 15.0046 13.3547 15.0046C14.2557 15.0046 14.9867 14.2566 14.9867 13.3556C14.9867 12.4546 14.2557 11.7236 13.3547 11.7236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.29236d3034be6406caf904a7fdb23eda.svg";
export { ForwardRef as ReactComponent };